import { NavLink } from 'react-router-dom';
import { Youtube, X, Instagram, MessageSquare, Coffee } from 'lucide-react';
import { SF_UI } from './ui/tokens';

const Footer = () => {
  const linkClass =
    'text-slate-300 hover:text-white transition-colors text-sm';

  return (
    <footer
      data-sf-ui="chrome-footer"
      className={`${SF_UI.systemId} ${SF_UI.footerShell} py-12`}
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="space-y-4">
            <div className="flex items-center">
              <img
                src="/SFUT_icon_small.png"
                alt="SportsFuture Logo"
                className="h-12 w-12 rounded-xl"
              />
              <span className="ml-2 text-xl font-bold tracking-tight">SportsFuture</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Empowering athletes worldwide through decentralized funding and support.
            </p>
            <div className="flex space-x-3">
              {[
                {
                  href: 'https://www.youtube.com/@SportsFutureio',
                  label: 'YouTube',
                  icon: Youtube,
                },
                { href: 'https://x.com/secretgiant1', label: 'X (Twitter)', icon: X },
                {
                  href: 'https://www.instagram.com/skyapertum/',
                  label: 'Instagram',
                  icon: Instagram,
                },
                {
                  href: 'https://t.me/SPORTSFUTURE',
                  label: 'Telegram',
                  icon: MessageSquare,
                },
              ].map(({ href, label, icon: Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-slate-300 transition hover:bg-white/10 hover:text-white"
                  aria-label={label}
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className={`mb-4 ${SF_UI.microLabel}`}>Quick Links</h3>
            <nav className="flex flex-col space-y-2.5">
              <NavLink to="/" className={linkClass}>
                Home
              </NavLink>
              <NavLink to="/about" className={linkClass}>
                About Us
              </NavLink>
              <NavLink to="/how-it-works" className={linkClass}>
                How It Works
              </NavLink>
              <NavLink to="/apply" className={linkClass}>
                Apply Now
              </NavLink>
              <a
                href="https://openplaza.io"
                target="_blank"
                rel="noopener noreferrer"
                className={linkClass}
              >
                NFT Marketplace
              </a>
              <NavLink to="/legacy" className={linkClass}>
                Legacy
              </NavLink>
              <NavLink to="/legacy/classics" className={`${linkClass} flex items-center`}>
                Classics
                <span className="ml-2 px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full uppercase">
                  New
                </span>
              </NavLink>
              <NavLink to="/legacy/one-world" className={`${linkClass} flex items-center`}>
                One World
                <span className="ml-2 px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded-full uppercase">
                  New
                </span>
              </NavLink>
            </nav>
          </div>

          <div>
            <h3 className={`mb-4 ${SF_UI.microLabel}`}>Resources</h3>
            <nav className="flex flex-col space-y-2.5">
              <NavLink to="/faq" className={linkClass}>
                FAQ
              </NavLink>
              <NavLink to="/news" className={linkClass}>
                News
              </NavLink>
              <a
                href="https://www.youtube.com/@SportsFutureio"
                target="_blank"
                rel="noopener noreferrer"
                className={`${linkClass} flex items-center`}
              >
                Community Hub
                <span className="ml-2 text-[10px] font-bold bg-primary text-white px-1.5 py-0.5 rounded-full uppercase">
                  New
                </span>
              </a>
              <a
                href="https://apertumsportsfuture-shop.fourthwall.com/"
                target="_blank"
                rel="noopener noreferrer"
                className={`${linkClass} flex items-center`}
              >
                Retail Plaza
                <span className="ml-2 text-[10px] font-bold bg-primary text-white px-1.5 py-0.5 rounded-full uppercase">
                  New
                </span>
              </a>
              <NavLink to="/token" className={linkClass}>
                Token
              </NavLink>
              <NavLink to="/legal" className={linkClass}>
                Legal
              </NavLink>
            </nav>
          </div>

          <div>
            <h3 className={`mb-4 ${SF_UI.microLabel}`}>Blockchain</h3>
            <div className="text-slate-300 space-y-2 text-sm">
              <p>Powered by Apertum Blockchain</p>
              <a
                href="https://apertum.io/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-primary-200 hover:text-white transition-colors"
              >
                Apertum Blockchain
              </a>
              <div>
                <a
                  href="https://explorer.apertum.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block text-primary-200 hover:text-white transition-colors"
                >
                  Blockchain Explorer
                </a>
              </div>
              <div className="mt-3">
                <p className="text-xs font-medium text-slate-400">SFUT Token Address</p>
                <p className="mt-1 text-xs break-all rounded-xl border border-white/10 bg-white/5 p-2.5 font-mono text-slate-300">
                  0xA8532d029320AD0176EfD0959e044aA610A751Ed
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col items-center">
          <p className="text-slate-400 text-sm mb-3 text-center">
            Thank you for sharing the passion to empower athletes around the world!
          </p>
          <a
            href="https://www.buymeacoffee.com/sportsfuture"
            target="_blank"
            rel="noopener noreferrer"
            className={`${SF_UI.ctaPrimary} gap-2`}
            style={{ backgroundColor: '#5F7FFF' }}
          >
            <Coffee size={18} />
            <span>Buy me a coffee</span>
          </a>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 text-center text-slate-500 text-sm">
          <p>© 2026 SportsFuture. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
